<div class="login-body flex align-content-center justify-content-center align-items-center flex-column p-5 ">
    <!-- <a href="">
        <img alt="Logo" src="../../../assets/layout/images/login/logo-vertical-plannerbus_conductores.png" class="h-10rem">
    </a> -->
    <p-card>
        <div class="grid">
            <div class="col-12 flex justify-content-center">
                <img alt="Logo" src="../../../assets/layout/images/login/logo-vertical-plannerbus_conductores.png"
                    class="h-15rem">

            </div>
        </div>
        <form class="grid" *ngIf="form" [formGroup]="form" (ngSubmit)="submit()">
            <div class="col-12 field">

                <label for="empresa">Conexión</label>
                <input id="empresa" formControlName="empresa" type="text" pInputText autocomplete="company">

            </div>
            <div class="col-12 field">
                <label for="usuario">Usuario</label>
                <input id="usuario" formControlName="login" type="text" pInputText autocomplete="username">

            </div>
            <div class="col-12 field">
                <label for="contrasena">Contraseña</label>
                <input
                    id="contrasena"
                    formControlName="password"
                    type="password"
                    pInputText
                    autocomplete="current-password"
                />

            </div>
            <div class="col-12">
                <button pButton pRipple type="submit" label="Conectar" class="p-button-outlined w-full"
                    [loading]="loading" icon="fa-solid fa-arrow-right-to-bracket"></button>
                <!-- <i class="fa-solid fa-arrow-right-to-bracket"></i> -->
            </div>
            <div class="col-12 text-center	">
                <button pButton pRipple type="button" label="Política de privacidad" class="p-button-info p-button-text"
                    (click)="openPoliticaPrivacidad()"></button>

            </div>
        </form>
        <ng-template pTemplate="footer">
            <div class="login-version-footer">v. {{ version }}</div>
        </ng-template>
    </p-card>
</div>